import { useEffect } from 'react';

import { TooltipWrapper, TooltipTrigger, TooltipContent } from 'twyne-new.ui';

import { usePalette } from './context';

function Tiptap() {
  const { palette: { hover: { color, mouse = {} } }, tooltipOpen, onChangeTooltipOpen } = usePalette()

  useEffect(() => {
    setTimeout(() => {
      onChangeTooltipOpen(!!color)
    }, 500)
  }, [color, onChangeTooltipOpen])

  if (!color || !color?.hex) return null

  return <TooltipWrapper open={tooltipOpen} className='pointer-events-none'>
    <TooltipTrigger asChild className='pointer-events-none'>
      <div className='h-5 w-5 absolute pointer-events-none' style={{ top: mouse.y - 5, left: mouse.x - 20 }} />
    </TooltipTrigger>
    <TooltipContent className='pointer-events-none'>
      <div>{color?.name ? `Name: ${color?.name}` : ''}</div>
      <div>{color?.hex ? `Hex: ${color?.hex}` : ''}</div>
    </TooltipContent>
  </TooltipWrapper>
}

export default Tiptap
